import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { payMobx } from '@mobxStore'
import SelectBankCardModal from './SelectBankCardModal'

interface IProps {
  channel?: TPayChannelType;
  bankCards?: any[];
  selected: boolean;
  amount: number;
  card: any;
  onChange: (data?: any) => void;
}

const BankCardSimpleItem: FC<IProps> = ({ channel, bankCards, selected, amount, onChange, card }) => {
  bankCards = bankCards || payMobx?.bankCards
  const multiUse = payMobx.methodChannelMap.bankCardOnline !== 'HeartLandBankCard' || (payMobx.channelAccountMap.HeartLandBankCard && payMobx.channelAccountMap.HeartLandBankCard.tokenType === 'multi')

  // 附加费
  const surchargeInfo = selected && card && card.number ? (card?.cardType && card?.cardType !== 'N' ? payMobx.surchargeMap?.[channel] : null) : payMobx.surchargeMap?.[channel]
  const surcharge = surchargeInfo ? amount * (surchargeInfo.rate / 100) : 0

  const handleChange = () => {
    if (selected && multiUse && bankCards?.length > 0) {
      modalLayer(SelectBankCardModal, { payRechargeFlag: true, bankCards, selectedCard: card }, 'selectBankCardModal').then((data: any) => {
        onChange(data)
      }).catch(() => {
        onChange()
      })
    } else {
      onChange()
    }
  }

  return (
    <div
      className={classNames(
        'pay-method-item',
        'bank-card-online',
        { selected }
      )}
      data-cypid='bankCardSimpleItem'
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-xinyongka'> </i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          {
            selected && card && card.number ? (
              <div className='name'>{format.maskCardNumber(card.number)}</div>
            ) : (
              <div className='name'>
                {i18n.t('pay.bankCard')}
              </div>
            )
          }
          {surchargeInfo && !!surcharge && (
            <div className='sub-name'>
              {i18n.t('pay.surcharge.cardTip', { name: surchargeInfo.name, rate: `${surchargeInfo.rate}%`, amount: format.toPrice(surcharge) })}
            </div>
          )}
          {bankCards?.length > 0 ? (<div className='triangle-tip'></div>) : ''}
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount + surcharge)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(BankCardSimpleItem)
